import React from "react";
import { withTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import AnomalyInfoTip from "../../AnomalyInfoTip";
import AnomalyPeriodSelector from "../../AnomalyPeriodSelector";
import TIMELINE_RULE_LENS from "../constants/timelineRuleLens";

const FilterBar = ({
  t,
  metricId,
  metricName,
  branchId,
  branchName,
  datapointId,
  datapointName,
  childBranches = [],
  isLoadingBranches = false,
  status,
  severity,
  ruleCode,
  onPeriodChange,
  onBranchChange,
  onStatusChange,
  onSeverityChange,
  onRuleCodeChange,
  onClearBranch,
  onClearDatapoint,
}) => {

  return (
    <div className="mat-filter-card anomaly-filter-card" data-testid="mat-filter-bar">
      <div className="mat-filter-header">
        <h6>{t("MetricAnomalyTimeline.filters.label")}</h6>
      </div>
      <div className="mat-filter-body">
        <div className="mat-context-chips">
          {metricId ? (
            <span className="mat-chip mat-chip-metric">
              <span className="mat-chip-label">{t("AnomalyDetection.metric.label")}</span>
              <strong>{metricName || metricId}</strong>
            </span>
          ) : (
            <span className="mat-chip mat-chip-warning">
              {t("MetricAnomalyTimeline.noMetricSelected.label")}
            </span>
          )}
          {branchId && (
            <span className="mat-chip">
              <span className="mat-chip-label">{t("AnomalyDetection.branch.label")}</span>
              <strong>{branchName || branchId}</strong>
              <button type="button" className="mat-chip-clear" onClick={onClearBranch} aria-label={t("MetricAnomalyTimeline.clearBranch.label")}>×</button>
            </span>
          )}
          {datapointId && (
            <span className="mat-chip">
              <span className="mat-chip-label">{t("MetricAnomalyTimeline.datapoint.label")}</span>
              <strong>{datapointName || datapointId}</strong>
              <button type="button" className="mat-chip-clear" onClick={onClearDatapoint} aria-label={t("MetricAnomalyTimeline.clearDatapoint.label")}>×</button>
            </span>
          )}
        </div>

        <div className="control-row">
          <div className="control-group">
            <label className="label-with-tip">
              {t("AnomalyDetection.period.label")}
              <AnomalyInfoTip text={t("AnomalyDetection.periodFilterToolTip.label")} />
            </label>
            <AnomalyPeriodSelector
              onChange={(from, to) => onPeriodChange(from, to)}
            />
          </div>
          <div className="control-group">
            <label className="label-with-tip">
              {t("AnomalyDetection.childBranch.label")}
              <AnomalyInfoTip text={t("AnomalyDetection.childBranchFilterToolTip.label")} />
            </label>
            <Form.Select
              value={branchId ? String(branchId) : ""}
              onChange={onBranchChange}
              disabled={isLoadingBranches}
              aria-label={t("AnomalyDetection.childBranch.label")}
            >
              <option value="">{t("AnomalyDetection.allBranches.label")}</option>
              {childBranches.map((unit) => (
                <option key={unit.id} value={String(unit.id)}>
                  {unit.name || "—"}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="control-group">
            <label className="label-with-tip">
              {t("AnomalyDetection.status.label")}
              <AnomalyInfoTip text={t("MetricAnomalyTimeline.statusFilterHelp.label")} />
            </label>
            <Form.Select value={status} onChange={(e) => onStatusChange(e.target.value)}>
              <option value="">{t("MetricAnomalyTimeline.statusAll.label")}</option>
              <option value="OPEN">{t("MetricAnomalyTimeline.statusOpen.label")}</option>
              <option value="DISMISSED">{t("MetricAnomalyTimeline.statusDismissed.label")}</option>
              <option value="RESOLVED">{t("MetricAnomalyTimeline.statusResolved.label")}</option>
            </Form.Select>
          </div>
          <div className="control-group">
            <label className="label-with-tip">
              {t("AnomalyDetection.severity.label")}
              <AnomalyInfoTip text={t("MetricAnomalyTimeline.severityFilterHelp.label")} />
            </label>
            <Form.Select value={severity} onChange={(e) => onSeverityChange(e.target.value)}>
              <option value="">{t("AnomalyDetection.allSeverities.label")}</option>
              <option value="CRITICAL">{t("AnomalyDetection.critical.label")}</option>
              <option value="HIGH">{t("AnomalyDetection.high.label")}</option>
              <option value="MEDIUM">{t("AnomalyDetection.medium.label")}</option>
              <option value="LOW">{t("AnomalyDetection.low.label")}</option>
            </Form.Select>
          </div>
          <div className="control-group">
            <label className="label-with-tip">
              {t("AnomalyDetection.ruleType.label")}
              <AnomalyInfoTip text={t("MetricAnomalyTimeline.ruleTypeFilterHelp.label")} />
            </label>
            <Form.Select value={ruleCode} onChange={(e) => onRuleCodeChange(e.target.value)}>
              {TIMELINE_RULE_LENS.map((rule) => (
                <option key={rule.value || "all"} value={rule.value}>
                  {t(rule.labelKey)}
                </option>
              ))}
            </Form.Select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(FilterBar);
